import Seo from "@/components/Seo";
import { PageHero } from "@/components/ui-bits";
import { COMPANY, PHONE_DISPLAY, EMAIL, ADDRESS } from "@/lib/site";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      `${COMPANY} ("we", "us") respects the privacy of every visitor. This policy explains what information we collect through this website and how it is used.`,
      "When you submit a quote request, sample request, contact enquiry or catalogue download, we collect the details you provide — such as your name, company, email address, country, phone number and requirement details — so that our export team can respond to your enquiry.",
      "Enquiry details are shared only with our internal team for the purpose of responding to your requirement. We do not sell or rent personal information to third parties.",
      "Enquiries sent to us by email or WhatsApp are handled in line with this policy as well. You may ask us to update or delete your enquiry details at any time by writing to " + EMAIL + ".",
      "This website may use analytics tools to understand aggregate visitor behaviour and improve the site. These tools do not identify individual visitors to us.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      "The content of this website is provided for general information about " + COMPANY + " and its food and agricultural product sourcing services for international B2B buyers.",
      "Product availability, grades, specifications, packaging, minimum order quantities and commercial terms are confirmed only through written quotations issued by our export team, and nothing on this website constitutes an offer, warranty or guarantee of supply.",
      "Product descriptions, specifications and packaging formats shown on this website are indicative and are finalized per order in the agreed contract documents.",
      "Use of the Request a Quote, sample request and contact forms for spam, solicitation or unlawful purposes is not permitted. We may restrict access to the website in such cases.",
      "All trademarks, logos and content on this website belong to " + COMPANY + " unless stated otherwise, and may not be reproduced without written permission.",
    ],
  },
  cookies: {
    title: "Cookie Policy",
    body: [
      "This website uses cookies and similar technologies to function correctly and to understand aggregate, anonymous usage through analytics tools.",
      "Essential cookies may be used for basic site functionality and security. Analytics cookies help us understand which pages are visited most, so we can improve the experience for international buyers.",
      "You can control or delete cookies through your browser settings. Doing so will not prevent you from browsing this website or submitting an enquiry.",
      "Questions about this policy can be sent to " + EMAIL + ".",
    ],
  },
};

export default function Legal({ kind = "privacy" }) {
  const c = CONTENT[kind] || CONTENT.privacy;
  return (
    <>
      <Seo title={`${c.title} — Orvella Overseas`} description={`${c.title} for the Orvella Overseas website.`} path={`/${kind === "privacy" ? "privacy-policy" : kind === "terms" ? "terms-conditions" : "cookie-policy"}`} />
      <PageHero eyebrow="Legal" title={c.title} />
      <section className="section-pad">
        <div className="container-x max-w-3xl space-y-5 text-sm leading-relaxed text-ink/90">
          {c.body.map((p, i) => <p key={i}>{p}</p>)}
          <p className="pt-4 text-xs text-mist">{COMPANY} · {ADDRESS} · {PHONE_DISPLAY} · {EMAIL}</p>
        </div>
      </section>
    </>
  );
}
